module.exports = __webpack_public_path__ + "assets/legend-80327f50bf6d7acc02b6c2dc20c61334.svg";